'use client';

import { useEffect } from "react";

function TechStack() {
  return (
    <div className="pt-6 text-color-2">
      <h1 className="text-3xl font-bold text-center text-color-1 mb-6">
        Programming Languages & Technologies Used At Centera Tech
      </h1>

      <section className="space-y-6">
        {/* Intro Section */}
        <div>
          <p className="text-lg mb-4">
            At <span className="text-color-1 font-medium">Centera Tech</span>,
            we leverage a wide range of modern programming languages and
            frameworks to deliver innovative, robust, and scalable solutions
            tailored to our clients’ needs.
          </p>
        </div>

        {/* Frontend Development Section */}
        <div>
          <h2 className="text-xl font-semibold text-color-1 mb-2">
            Frontend Development
          </h2>
          <ul className="list-disc list-inside space-y-2 mb-4">
            <li>
              <strong>HTML & CSS</strong>: Building intuitive and responsive
              user interfaces.
            </li>
            <li>
              <strong>JavaScript</strong>: Powering dynamic and interactive web
              experiences.
            </li>
            <li>
              <strong>React JS</strong>: Crafting fast and scalable web
              applications.
            </li>
            <li>
              <strong>React Native</strong>: Developing cross-platform mobile
              applications.
            </li>
          </ul>
        </div>

        {/* Backend Development Section */}
        <div>
          <h2 className="text-xl font-semibold text-color-1 mb-2">
            Backend Development
          </h2>
          <ul className="list-disc list-inside space-y-2 mb-4">
            <li>
              <strong>Python</strong>: For scalable backend systems, data
              processing, and automation.
            </li>
            <li>
              <strong>PHP</strong>: Powering web solutions with efficient
              server-side scripting.
            </li>
            <li>
              <strong>Laravel</strong>: Delivering elegant and secure backend
              frameworks for complex applications.
            </li>
          </ul>
        </div>

        {/* Full-Stack Development Section */}
        <div>
          <h2 className="text-xl font-semibold text-color-1 mb-2">
            Full-Stack Development
          </h2>
          <ul className="list-disc list-inside space-y-2 mb-4">
            <li>
              <strong>Electron JS</strong>: Creating cross-platform desktop
              applications.
            </li>
          </ul>
        </div>

        {/* Database Management Section */}
        <div>
          <h2 className="text-xl font-semibold text-color-1 mb-2">
            Database Management
          </h2>
          <ul className="list-disc list-inside space-y-2 mb-4">
            <li>
              <strong>MySQL</strong>: Relational database management for
              structured data.
            </li>
            <li>
              <strong>MongoDB</strong>: Flexible NoSQL solutions for
              unstructured and semi-structured data.
            </li>
          </ul>
        </div>

        {/* Content Management Systems Section */}
        <div>
          <h2 className="text-xl font-semibold text-color-1 mb-2">
            Content Management Systems
          </h2>
          <ul className="list-disc list-inside space-y-2 mb-4">
            <li>
              <strong>WordPress</strong>: Customizable and user-friendly CMS
              solutions.
            </li>
          </ul>
        </div>

        {/* Conclusion Section */}
        <div>
          <p className="text-lg">
            By employing this diverse technology stack,{" "}
            <span className="text-color-1 font-medium">Centera Tech</span>{" "}
            ensures high-quality software solutions that meet the evolving
            demands of businesses across industries.
          </p>
        </div>
      </section>
    </div>
  );
}

export default TechStack;
